import { Classes, Styles } from "jss";
import { createUseStyles } from "react-jss";
import { ThemeItem } from "../../../theme";
import { SectionBuilderProps } from ".";

export type SectionBuilderClassNames =
  | "section"
  | "wrapper"
  | "imgLogo"
  | "contentBox"
  | "contentIcon"
  | "contentIconBox"
  | "contentTitle"
  | "contentDesc"
  | "contentDetailsLink"
  | "contentDetailsText"
  | "sliderSectionTitle"
  | "sliderSectionTitleText";
export type SectionBuilderClasses = Classes<SectionBuilderClassNames>;
export type SectionBuilderStyles = Styles<SectionBuilderClassNames>;
export type SectionBuilderStylesProps = SectionBuilderProps;

const getStyles: (theme: ThemeItem) => SectionBuilderStyles = (
  theme: ThemeItem
) => ({
  sliderSectionTitle: {
    textAlign: "center",
    margin: "0",
    paddingTop: "50px",
    paddingBottom: "20px",
  },
  sliderSectionTitleText: {
    fontSize: 28,
    letterSpacing: "-0.7px",
    fontWeight: 300,
    opacity: 0,
    color: "#25262c",
  },
  "@media (max-width: 600px)": {
    sliderSectionTitle: { paddingTop: "50px !important" },
  },
  "@media (max-width: 992px)": {
    wrapper: { flexDirection: "column !important", padding: "0px !important" },
    contentDesc: { maxWidth: "none !important", fontSize: "18px !important" },
    imgLogo: { width: "210px !important" },
    contentBox: {
      padding: "0 20px !important",
      textAlign: "center",
      marginTop: 25,
    },
    sliderSectionTitleText: {
      opacity: 1,
      fontSize: 18,
      padding: "0 22px",
      lineHeight: 1.5,
    },
  },
  section: ({ sectionMargin = [] }: SectionBuilderStylesProps) => ({
    // margin: "90px 0 0 0",
  }),
  wrapper: ({ sectionDirection = "rtl" }: SectionBuilderStylesProps) => ({
    flexDirection: sectionDirection === "rtl" ? "row" : "row-reverse",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }),
  imgLogo: { width: 280, opacity: 1 },
  contentBox: ({ contentBoxPadding = [] }: SectionBuilderStylesProps) => ({
    // padding: [0, 0, 0, 105],
    opacity: 1,
  }),
  contentIcon: { width: 60 },
  contentIconBox: { opacity: 1 },
  contentTitle: {
    opacity: 1,
    fontSize: 28,
    fontWeight: 400,
    // color: "#25262C",
    color: "#000066",
    marginTop: 15,
    lineHeight: 1.3,
  },
  contentDesc: {
    // opacity: 1,
    fontSize: 14,
    fontWeight: 300,
    color: "#484848",
    // color: "#CACBCC",
    marginTop: 15,
    maxWidth: "70%",
    lineHeight: 1.5,
  },
  contentDetailsLink: {
    fontWeight: 300,
    marginTop: 15,
    display: "inline-flex",
    alignItems: "center",
    color: "#6E6E6F",
    transition: ".2s all",
    "&:hover": {
      opacity: "0.7",
    },
  },
  contentDetailsText: {
    fontWeight: 200,
    paddingBottom: 2,
    paddingRight: 2,
  },
});

const useSectionStyles: (
  data?: SectionBuilderStylesProps
) => SectionBuilderClasses = createUseStyles<
  ThemeItem,
  SectionBuilderClassNames
>(getStyles);

export default useSectionStyles;
